import { ColDef } from 'ag-grid-community';
import { t } from 'i18next';

import { IElement } from 'bom/types';
import { DEFAULT_PLACEHOLDER } from 'core/constants';
import { Price } from 'core/elements';
import { AgGridFilterOption } from 'core/enums';
import { NumberHelper } from 'core/helpers';
import { IJob } from 'jobs/types';

import { ActionsCell } from './cells';

export const columnDef = (job: IJob) => {
  const isEditable = (element: IElement) => element.empty === 0;

  return [
    {
      colId: 'line',
      headerName: '#',
      pinned: 'left',
      field: 'line',
      wrapText: false,
      suppressPaste: true,
      suppressFillHandle: true,
      suppressSizeToFit: false,
      suppressHeaderMenuButton: true,
      resizable: false,
      minWidth: 80,
      width: 80,
      maxWidth: 80,
      suppressColumnsToolPanel: true,
      suppressMovable: true,
      lockPinned: true,
      enableValue: true,
      enablePivot: true,
      filter: 'agNumberColumnFilter',
      floatingFilter: false,
      headerClass: 'paddingSmall',
      valueFormatter: ({ value }) => (!value ? '' : value),
      cellStyle: { textAlign: 'center', fontWeight: 'bold' },
      cellRenderer: 'agGroupCellRenderer',
      cellRendererParams: { placeholder: '' },
    },
    {
      colId: 'actions',
      width: 50,
      maxWidth: 50,
      sortable: false,
      resizable: false,
      enableRowGroup: false,
      suppressHeaderMenuButton: true,
      suppressColumnsToolPanel: true,
      pinned: 'left',
      lockPinned: true,
      cellRenderer: ActionsCell,
      cellRendererParams: { job, isEditable },
      cellClass: 'noDecorationCell',
    },
    {
      colId: 'name',
      headerName: t('headerName'),
      field: 'name',
      filter: 'agTextColumnFilter',
      editable: ({ data }) => isEditable(data),
      flex: 4,
    },
    {
      colId: 'quantity',
      headerName: t('headerQuantity'),
      field: 'quantity',
      filter: 'agNumberColumnFilter',
      filterParams: {
        defaultOption: AgGridFilterOption.IN_RANGE,
      },
      editable: ({ data }) => isEditable(data),
      valueFormatter: ({ value }) => NumberHelper.format({ amount: value }),
      cellStyle: { textAlign: 'right' },
      cellRendererParams: { textEllipsis: false, sx: { justifyContent: 'flex-end' } },
      flex: 1,
    },
    {
      colId: 'cost',
      headerName: t('headerUnitCost'),
      field: 'cost',
      filter: 'agNumberColumnFilter',
      filterParams: {
        defaultOption: AgGridFilterOption.IN_RANGE,
      },
      enableValue: true,
      enablePivot: true,
      valueFormatter: ({ value }) => (value ? <Price amount={value} /> : DEFAULT_PLACEHOLDER),
      cellRendererParams: { textEllipsis: false, sx: { justifyContent: 'flex-end' } },
      flex: 1.5,
    },
    {
      colId: 'extendedCost',
      headerName: t('headerExtCost'),
      field: 'extendedCost',
      filter: 'agNumberColumnFilter',
      filterParams: {
        defaultOption: AgGridFilterOption.IN_RANGE,
      },
      suppressPaste: true,
      suppressFillHandle: true,
      enableValue: true,
      enablePivot: true,
      aggFunc: 'sum',
      valueFormatter: ({ value }) => (value ? <Price amount={value} /> : DEFAULT_PLACEHOLDER),
      cellRendererParams: { textEllipsis: false, sx: { justifyContent: 'flex-end' } },
      flex: 1.5,
    },
  ] as ColDef[];
};
